<template>
  <div class="bt hidden-x pb-72">
    <div v-if="customization">
      <md-list arrow>
        <md-list-item
          ><md-field
            v-model="noticeGroupName"
            :maxlength="20"
            label="通知组名称"
            width="100"
            placeholder="请输入，最多20个字"
          ></md-field
        ></md-list-item>
        <md-list-item title="通知人员" @click="handlerChoose">
          <span slot="description">{{ selectedText }}</span>
        </md-list-item>
      </md-list>
      <md-anchor>通知人员请选择角色组内成员</md-anchor>
    </div>

    <div class="bg-FFFFFF" v-for="(item, index) in settingList" :key="index">
      <div class="bg-FFFFFF mt-16 bb">
        <md-switch
          :value="computedSelectedTypes.includes(item.id)"
          @change="checked => handlerIsSelected(checked, item.id)"
        >
          <div class="ff-regular font-34">
            <p>{{ item.title }}</p>
            <p class="c-171A1D-40 font-26">{{ item.subTitle }}</p>
          </div>
        </md-switch>
        <md-list
          v-if="
            (item.triggerConditions || []).length &&
            computedSelectedTypes.includes(item.id)
          "
          arrow
        >
          <md-list-item
            v-for="child in item.triggerConditions"
            :key="child.title"
            :title="child.title"
            @click="handlerChooseValue(child)"
            v-show="
              child.value.replace(
                `{value}`,
                child.threshold || child.defaultValue
              )
            "
          >
            <span class="c-171A1D-40" slot="description">{{
              child.value.replace(
                `{value}`,
                child.threshold || child.defaultValue
              )
            }}</span>
          </md-list-item>
        </md-list>
      </div>
      <!-- 班级放学专用 -->
      <div
        v-if="
          computedSelectedTypes.includes(item.id) &&
          moduleId === 30 &&
          item.id === 2
        "
      >
        <md-list arrow>
          <md-list-item title="学生离校时间" @click="methodToSetNoticeTime">
            <span slot="description">{{ computedLeaveSchoolTime }}</span>
          </md-list-item>
        </md-list>
        <p class="lh-18 c-171A1D-40 font-26 mb-24 p-0-16 bg-F6F6F6 pt-8"
          >放学后学生{{ studentLeaveSchoolTime }}分钟内未离校发送通知
        </p>
      </div>
      <!-- 班级放学专用 -->
      <div
        v-if="
          computedSelectedTypes.includes(item.id) &&
          (item.triggerConditions || []).length &&
          moduleId === 30 &&
          item.id === 4
        "
      >
        <md-list arrow>
          <md-list-item title="发送通知时间" @click="openNoticeTime = true">
            <span slot="description">{{
              handlerTime(noticeTime, +item.triggerConditions[0].period)
            }}</span>
          </md-list-item>
        </md-list>
        <p class="lh-18 c-171A1D-40 font-26 mb-24 p-0-16 bg-F6F6F6 pt-8"
          >每天固定时间发送统计通知给家长
        </p>
        <md-picker
          v-model="openNoticeTime"
          :columns="noticeTimeList"
          @confirm="noticeTimeConfirm"
          @cancel="noticeTimeCancel"
          @change="noticeTimeChange"
        >
        </md-picker>
      </div>
    </div>
    <common-notice-tip class="mt-10" v-if="[2, 5].includes(noticeType)">
    </common-notice-tip>
    <p
      class="lh-28 p-0-16 c-171A1D-40 font-26"
      v-if="+noticeType === 3 && moduleId === 1"
    >
      选中后，家长会收到学生到校或者离校的通知。
    </p>
    <div
      class="footer fb fb-main-start fb-cross-center"
      v-show="+noticeType === 5"
    >
      <md-button
        @click="handlerDeleteInfo"
        type="submary"
        class="mr-8"
        v-if="computedShowDeleteButton"
        >删除</md-button
      >
      <md-button @click="fetchPreserveRole">保存</md-button>
    </div>
  </div>
</template>

<script>
import { mcAlert, mcConfirm, mcSetTitle } from '@/utils/mcSdkUtils'
import { IS_IOS, resultText, dateZeroFill, getItem } from '@/utils/comUtils'
import { ALL_SETTING_LIST, INIT_CONFIG_LIST } from '@/utils/noticeUtils'
import API from '@/api'
import commonNoticeTip from './commonNoticeTip'
import mixin from '@/mixin'
import { PAGE_IN_MODULE } from '@/utils/constUtils'
export default {
  mixins: [mixin],
  components: { commonNoticeTip },
  props: {
    //   attendance: 1 考勤;  leave: 2 请假;  dorm: 4 宿管;   classover: 30 班级放学;
    moduleId: {
      type: Number,
      default: 1
    },
    moduleType: {
      type: Number,
      default: 1
    },
    customization: {
      type: Boolean,
      default: false
    },
    noticeGroupId: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    // noticeType 通知组类型: 1、管理员 2、老师 3、父母 4、任课老师 5、其他
    noticeType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      IS_IOS,
      memberGroupId: null,
      noticeDtoList: [],
      noticeDtoObj: {},
      userList: [],
      roleGroupList: [],
      settingList: [],
      noticeGroupName: this.name,
      studentLeaveSchoolTime: '20',
      activeIndex: -1,
      selectedText: '',
      openNoticeTime: false,
      noticeTime: '',
      noticeTimeList: [
        {
          options: new Array(9).fill(null).map((item, index) => {
            return {
              name: dateZeroFill(`${index + 6}`)
            }
          }),
          defaultActive: 8
        },
        {
          options: new Array(12).fill(null).map((item, index) => {
            return dateZeroFill(`${5 * index}`)
          }),
          defaultActive: 0
        }
      ]
    }
  },
  computed: {
    computedShowDeleteButton() {
      return +this.noticeType === 5 && this.noticeGroupId
    },
    computedSelectedTypes() {
      return (
        (this.noticeDtoList || [])
          .filter(dto => `${dto.noticeStyleType}` === '1')
          .map(notice => notice.noticeEventType) || []
      )
    },
    computedLeaveSchoolTime() {
      return `${this.studentLeaveSchoolTime}分钟`
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {
      const { noticeGroupName, noticeGroupId, noticeType } = this
      this.noticeDtoObj = {}
      mcSetTitle(noticeType === 5 ? '自定义通知组' : noticeGroupName)
      if (noticeGroupId) {
        this.handlerGetGroupDetail({
          noticeType,
          noticeGroupId,
          noticeVersion: 1
        })
      } else {
        this.initConfig()
      }
    },
    // 获取每个角色的权限详情
    handlerGetGroupDetail(params) {
      API.getNoticeGroupDetail(params)
        .then(res => {
          res.dingUserList.forEach(item => {
            item.name = item.dingName
            item.avatar = item.avatar || item.dingAvatar
            item.emplId = item.dingUserId
          })
          res.memberGroupId && (this.memberGroupId = res.memberGroupId)
          this.userList = res.dingUserList || []
          this.roleGroupList = res.roleGroupDtoList || []
          this.noticeDtoList = res.noticeDtoList || []
          this.selectedText = resultText(this.roleGroupList, this.userList)
          this.studentLeaveSchoolTime = res.studentLeaveSchoolTime || '20'
          this.noticeDtoList.forEach(item => {
            const configs = ALL_SETTING_LIST[this.moduleId]()
            const triggerConditions =
              (configs.find(md => md.id === item.noticeEventType) || {})
                .triggerConditions || []
            this.noticeDtoObj[item.noticeEventType] = {
              ...item,
              triggerConditions: (item.triggerConditions || []).map(trg => {
                return {
                  ...triggerConditions.find(
                    md => md.conditionType === trg.conditionType
                  ),
                  ...trg
                }
              })
            }
          })
          this.initConfig()
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    // 勾选通知
    handlerIsSelected(checked, noticeEventType) {
      let _hasType = false
      const noticeStyleType = checked ? '1' : '0'
      this.noticeDtoList.forEach(item => {
        if (noticeEventType === item.noticeEventType) {
          _hasType = true
          item.noticeStyleType = noticeStyleType
        }
      })
      if (!_hasType) {
        this.noticeDtoList.push({
          noticeEventType,
          noticeStyleType
        })
      }
      if (+this.noticeType !== 5) {
        this.handlerIsSure()
      }

      // 判断如果是智慧停车 查询是否配置了超时停车时间
      if (this.moduleId === PAGE_IN_MODULE.vehiclemanage) {
        // 调用接口
        API.getLimitConfig(this.commonParams)
          .then(res => {
            if (this.hasError(res)) {
              return this.$Toast({
                type: 'fail',
                content: res.message
              }).show()
            }
            if ((!res.enabledTimeout || !res.limitTime) && checked) {
              mcAlert({
                msg: '还未配置超时停车时间，无法发送「超时停车」通知。',
                title: '开启提示',
                buttonName: '我知道了',
                closeOnPopstate: false
              })
            }
          })
          .catch(err =>
            this.$Toast({
              type: 'fail',
              content: err.message
            }).show()
          )
      }
    },
    // 时时更新保存数据接口
    handlerIsSure() {
      const {
        memberGroupId,
        noticeGroupId,
        noticeGroupName,
        noticeDtoList,
        noticeType,
        studentLeaveSchoolTime,
        roleGroupList,
        userList
      } = this
      const roleGroupIds = roleGroupList.map(group => {
        return group.roleGroupId
      })
      const members = userList
        .map(user => {
          return user.dingUserId
        })
        .join(',')

      let _noticeDtoList = noticeDtoList.map(item => {
        const triggerConditions = (
          (this.settingList.find(set => set.id === item.noticeEventType) || {})
            .triggerConditions || []
        ).map(opt => {
          return {
            conditionType: opt.conditionType,
            threshold: opt.threshold
          }
        })
        return {
          ...item,
          // 班级放学强制保存
          triggerConditions: [30].includes(+this.moduleId)
            ? (item.triggerConditions || []).length
              ? item.triggerConditions
              : triggerConditions
            : triggerConditions
        }
      })
      // 定制代码：考勤组通知，家长场景下 存在上学通知，同步上学通知和迟到开关状态
      if (
        _noticeDtoList.find(v => v.noticeEventType === 1) &&
        this.moduleId === 1 &&
        this.moduleType === 2 &&
        this.name === '家长'
      ) {
        let _index = _noticeDtoList.findIndex(v => v.noticeEventType === 3)
        if (_noticeDtoList[_index]) {
          _noticeDtoList[_index].noticeStyleType = _noticeDtoList.find(
            v => v.noticeEventType === 1
          ).noticeStyleType
        } else {
          _noticeDtoList.push({
            noticeEventType: 3,
            noticeStyleType: _noticeDtoList.find(v => v.noticeEventType === 1)
              .noticeStyleType,
            triggerConditions: []
          })
        }
      }
      const param = {
        memberGroupId,
        noticeGroupId,
        noticeGroupName,
        noticeDtoList: _noticeDtoList,
        noticeType,
        moduleType: this.moduleType,
        members,
        roleGroupIds
      }
      if (this.moduleId === 30) {
        param.studentLeaveSchoolTime = studentLeaveSchoolTime
      }
      API.updateNoticeGroup(param)
        .then(res => {
          if (res.result !== '0' && res.message) {
            mcAlert({ msg: res.message })
          } else if (+noticeType === 5) {
            this.$router.go(-1)
          }
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    // 新增数据接口
    fetchPreserveRole() {
      const {
        selectedText,
        noticeGroupName,
        userList,
        memberGroupId,
        noticeDtoList,
        moduleType,
        studentLeaveSchoolTime,
        roleGroupList
      } = this
      if (!noticeGroupName) {
        mcAlert({ msg: '请输入角色名称' })
        return
      }
      if (!selectedText) {
        mcAlert({ msg: '请输入通知人员' })
        return
      }
      if (memberGroupId) {
        this.handlerIsSure()
      } else {
        const roleGroupIds = roleGroupList.map(group => {
          return group.roleGroupId
        })
        const members = userList
          .map(user => {
            return user.dingUserId
          })
          .join(',')
        const param = {
          noticeGroupName,
          noticeDtoList: noticeDtoList.map(item => {
            const triggerConditions = (
              this.settingList.find(set => set.id === item.noticeEventType)
                .triggerConditions || []
            ).map(opt => {
              return {
                conditionType: opt.conditionType,
                threshold: opt.threshold
              }
            })
            return {
              ...item,
              triggerConditions
            }
          }),
          noticeType: 5,
          moduleType,
          members,
          roleGroupIds
        }
        if (this.moduleId === 30) {
          param.studentLeaveSchoolTime = studentLeaveSchoolTime
        }
        API.saveNoticeGroup(param)
          .then(res => {
            if (res.message) {
              mcAlert({ msg: res.message })
              return ''
            } else {
              this.$router.go(-1)
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    // 获取通讯录
    handlerChoose() {
      let _addressBook = {
        corpName: this.corpName,
        campusId: this.campusId,
        operUserRoleTypes: `${this.currentRole}`,
        doubleBack: true,
        title: '通知人员',
        selectedData: {
          selectedGroup: this.roleGroupList,
          selectedUser: this.userList
        }
      }
      mcSetTitle('通知人员')
      this.$customRoleGroup(_addressBook)
        .then(res => {
          mcSetTitle('自定义通知组')
          console.log('自定义通知组', res)
          const { selectedGroup = [], selectedUser = [] } = res
          this.roleGroupList = selectedGroup
          this.userList = selectedUser
          this.selectedText = resultText(selectedGroup, selectedUser)
          this.$emit('close')
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 删除该通知组
    handlerDeleteInfo() {
      mcConfirm({
        msg: '你确认删除该角色吗？',
        title: '提示'
      })
        .then(msg => {
          if (msg) {
            API.deleteNoticeGroup({
              noticeGroupId: this.noticeGroupId
            })
              .then(res => {
                this.$router.go(-1)
              })
              .catch(err => {
                console.log('unhandledrejection', err)
              })
          }
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },

    // 初始化常量配置
    initConfig() {
      let _settingIdList =
        INIT_CONFIG_LIST[this.moduleId][this.noticeType] || []
      const allSettingList = ALL_SETTING_LIST[this.moduleId](
        this.noticeType,
        (getItem('graybus') || '').indexOf(+this.moduleId) > -1
      )
      this.settingList = [...allSettingList].filter(item => {
        return _settingIdList.includes(item.id)
      })
      if (!this.noticeGroupId) {
        this.noticeDtoList = this.settingList.map(item => {
          return {
            noticeEventType: item.id,
            noticeStyleType: '0'
          }
        })
      } else {
        this.settingList.forEach(item => {
          item.triggerConditions =
            this.noticeDtoObj[item.id].triggerConditions || []
        })
      }
    },
    // 班级放学专属--设置放学时间
    async methodToSetNoticeTime() {
      let _timeList = []
      for (let i = 10; i <= 60; i += 10) {
        _timeList.push({ name: `${i}分`, value: `${i}` })
      }
      try {
        const _that = this
        this.$ActionSheet({
          title: '请选择',
          cancelText: '关闭',
          actions: _timeList,
          onChoose(item, index) {
            _that.activeIndex = index
            _that.studentLeaveSchoolTime = item.value
            if (+_that.noticeType !== 5) {
              _that.saveNoticeTime()
            }
          },
          active: _that.activeIndex
        }).show()
      } catch (err) {
        console.log(err)
      }
    },
    async saveNoticeTime() {
      try {
        await API.saveNoticeTime({
          campusId: this.campusId,
          noticeGroupId: this.noticeGroupId,
          operUserRoleType: this.noticeType,
          studentLeaveSchoolTime: this.studentLeaveSchoolTime
        })
      } catch (err) {}
    },
    noticeTimeConfirm(index, value, mutiple = false) {
      this.noticeTime = `${value[0].name}:${value[1]}`
      this.noticeDtoList.forEach(item => {
        if (+item.noticeEventType === 4) {
          this.$set(
            item.triggerConditions[0],
            'period',
            +value[0].name * 3600 + +value[1] * 60 || 50400
          )
        }
      })
      this.handlerIsSelected(true, 4)
    },
    handlerTime(noticeTime, time) {
      if (noticeTime) {
        return noticeTime
      }
      let _hour = ~~(time / 3600) || 14
      let _min = ~~((time % 3600) / 60) || 0
      this.noticeTimeList[0].defaultActive = _hour - 6
      this.noticeTimeList[1].defaultActive = ~~(_min / 5)
      return dateZeroFill(`${_hour}`) + ':' + dateZeroFill(`${_min}`)
    },
    noticeTimeCancel() {},
    noticeTimeChange() {},
    handlerChooseValue(child) {
      const columns = new Array(child.maxValue + 1 - child.minValue)
        .fill(null)
        .map(
          (item, index) =>
            (item = {
              name: `${index + child.minValue}${child.unit}`,
              value: index + child.minValue
            })
        )
      if (child.conditionType === 3) {
        const _that = this
        this.$Picker({
          columns,
          defaultActive: columns.findIndex(
            item => item.value === (child.threshold || child.defaultValue)
          ),
          onConfirm([_index], [col]) {
            _that.$set(child, 'threshold', col.value)
            // 默认角色 自动保存
            if (!_that.memberGroupId && !_that.customization) {
              _that.handlerIsSure()
            }
          }
        }).show()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-close-people {
  z-index: 1;
  top: 0;
  right: -4px;
  color: rgba(17, 31, 44, 1);
}
.footer {
  position: fixed;
  bottom: 0px;
  z-index: 2;
}

.add-padding-ios {
  padding-bottom: 3px;
}

.marginBottom {
  margin-bottom: 8px;
  border-bottom: 0 none;
}
.right {
  text-align: -webkit-right;
  text-align: right;
}
:deep .md-picker__highlight {
  &:after {
    content: ':';
    position: absolute;
    left: 50%;
    top: 0;
    font-size: 20px;
    line-height: 40px;
  }
}
</style>
